

import { useNavigate } from "react-router-dom";

// ── Promotion icons — replace paths with your actual files ──────────────────
import HaemoglobinIcon from "../../Assets/Images/smartvitals.svg";  // used on smartvital
import LanguageIcon    from "../../Assets/Images/rewamp/caresathi and symptom checker pill icon.svg";      // used on caresathi & symcheck
import TbScreeningIcon from "../../Assets/Images/lungscare/lungscare.svg";    // used on lungscare — dummy, replace with actual asset
import CosmeticFlowIcon from "../../Assets/Images/cosmeticSkin/hover state icon -cosmetic flow.svg";    // used on skincare

// Internal SPA routes — use React Router navigate() so the JS runtime
// (and any in-flight uploads) are never interrupted by a hard page reload.
const DIRECT_ROUTES = {
  skincare:         "/skincare",
  oralcare:         "/oralcare",
  lungscare:        "/lungscare",
  visioncare:       "/visioncare",
  symptomchecker:   "/symptomchecker",
  smartvitals:      "/smartvital",
  "smart report":   "/smartReport",
  "smart diet":     "/smartdiet",
  caresathi:        "/caresathi",
};

// External links only — still needs a full redirect
const endpointBase = process.env.REACT_APP_Curebay;

const gradientText = {
  fontFamily: "Inter, sans-serif",
  fontWeight: 700,
  fontSize: 24,
  lineHeight: 1.2,
  letterSpacing: "0.02em",
  color: "var(--color-brand-primary)",
  margin: "0 0 6px 0",
};

// Map of subheading key → { icon, label }
// Sparkle icon (lucide "sparkles") for the "New" badge — teal, matches the Figma pill
const NEW_BADGE_ICON = `data:image/svg+xml;utf8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0E9F7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>')}`;

const PROMOTIONS = {
  smartvitals:    { icon: HaemoglobinIcon, label: "Now with Haemoglobin Check" },
  caresathi:      { icon: LanguageIcon,    label: "Now in 8 languages" },
  symptomchecker: { icon: LanguageIcon,    label: "Now in 8 languages" },
  lungscare:      { icon: TbScreeningIcon, label: "TB Screening Support available now" },
  skincare:       { icon: CosmeticFlowIcon, label: "Now with Cosmetic Skincare Analysis" },
  visioncare:     { icon: NEW_BADGE_ICON,   label: "New", variant: "new" },
};

const styles = `
  .cb-section {
    background: transparent;
    padding: 40px max(60px, calc(50% - 660px)) 48px;
    font-family: Inter, sans-serif;
    width: 100%;
    box-sizing: border-box;
    margin-top: -120px;
    position: relative;
    z-index: 1;
  }

  /* ── Rows ── */
  .cb-top-row, .cb-bottom-row {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 30px;
    margin-bottom: 14px;
  }
  .cb-middle-row {
    display: grid;
    grid-template-columns: 5fr 4fr;
    gap: 14px;
    margin-bottom: 14px;
    align-items: stretch;
  }

  /* ── Heading block ── */
  .cb-heading-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 0 8px 4px;
    overflow: visible;
  }
  .cb-main-heading {
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 52px;
    line-height: 1.15;
    letter-spacing: 0.003em;
    color: var(--color-brand-primary);
    margin: 0 0 16px 0;
  }
  .cb-main-heading-accent { color: var(--color-brand-green); }
  .cb-main-desc {
    font-family: Inter, sans-serif;
    font-weight: 400;
    font-size: 30px;
    line-height: 1.4;
    letter-spacing: 0.01em;
    color: var(--color-text-subheading);
    margin: 0;
  }

  /* ── SmallCard ── */
  .cb-small-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #DFF1FB;
    box-shadow: 0px 0px 15px 0px #80DAF1;
    padding: 16px 16px 0 16px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: box-shadow 0.2s, transform 0.2s;
    height: 300px;
  }
  .cb-small-card:hover {
    box-shadow: 0px 0px 22px 0px #80DAF1;
    transform: translateY(-2px);
  }
  .cb-small-card-img-wrap {
    display: flex;
    justify-content: center;
    margin-top: 6px;
    flex: 1;
    overflow: hidden;
  }
  .cb-small-card-img {
    width: 100%;
    max-width: 310px;
    height: auto;
    max-height: 207px;
    object-fit: contain;
  }

  /* ── FeaturedCard ── */
  .cb-featured-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #DFF1FB;
    box-shadow: 0px 0px 15px 0px #80DAF1;
    padding: 24px 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 20px;
    transition: box-shadow 0.2s, transform 0.2s;
    min-height: 255px;
    box-sizing: border-box;
  }
  .cb-featured-card:hover {
    box-shadow: 0px 0px 22px 0px #80DAF1;
    transform: translateY(-2px);
  }
  .cb-featured-text { flex: 1; min-width: 0; }
  .cb-featured-img {
    width: 310px;
    height: 187px;
    object-fit: contain;
    flex-shrink: 0;
  }

  /* ── Promotion Badge ── */
  /* Badge sits in normal document flow — no absolute positioning —
     so it never overlaps the card title.                           */
  .cb-promo-badge-wrap {
    display: inline-flex;           /* shrink-wrap to content */
    align-self: flex-end;           /* pill sits top-right of the card */
    max-width: 100%;                /* never wider than the card — wrap instead of clipping */
    border: 1px solid #00B5E2;
    border-radius: 20px;
    margin-bottom: 8px;             /* spacing between badge and title */
    flex-shrink: 0;
  }
  .cb-promo-badge-inner {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 8px;
    border-radius: 19px;
    max-width: 100%;
    background: linear-gradient(282.08deg, #DFF1FB 2.51%, #FFFFFF 100.3%);
  }
  .cb-promo-badge-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
  .cb-promo-badge-label {
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: 0;
    color: var(--color-brand-primary);
    white-space: normal;
    word-break: break-word;
  }
  /* "New" badge (VisionCare): mint pill with a teal border, per Figma */
  .cb-promo-badge-wrap.cb-promo-badge-wrap--new { border-color: #2EC4A0; }
  .cb-promo-badge-inner.cb-promo-badge-inner--new { background: #DDF7EE; }
  .cb-promo-badge-inner--new .cb-promo-badge-label { font-weight: 700; }

  /* ── Tablet large (1101–1279px) ── */
  @media (max-width: 1279px) and (min-width: 1101px) {
    .cb-section { padding: 40px 40px 48px; }
    .cb-main-heading { font-size: 42px; }
    .cb-main-desc { font-size: 28px; }
    .cb-top-row, .cb-bottom-row { gap: 20px; }
    .cb-featured-img { width: 220px; height: auto; }
  }

  /* ── Tablet (768–1100px) ── */
  @media (max-width: 1100px) and (min-width: 768px) {
    .cb-section { padding: 32px 28px 40px; margin-top: -60px; }
    .cb-top-row, .cb-bottom-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
    }
    .cb-middle-row { grid-template-columns: 1fr; gap: 16px; }
    .cb-main-heading { font-size: 36px; }
    .cb-main-desc { font-size: 22px; }
    .cb-featured-card { flex-direction: row; min-height: auto; }
    .cb-featured-img { width: 200px; height: auto; }
    .cb-small-card { height: 260px; }
  }

  /* ── Mobile (max 767px) ── */
  @media (max-width: 767px) {
    .cb-section { padding: 20px 14px 32px; margin-top: -30px; }
    .cb-top-row, .cb-bottom-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
      margin-bottom: 10px;
    }
    .cb-middle-row {
      grid-template-columns: 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    .cb-main-heading { font-size: 26px; margin-bottom: 8px; }
    .cb-main-desc { font-size: 15px; }
    .cb-heading-block { padding: 4px 0; }

    /* Badge slightly smaller on mobile */
    .cb-promo-badge-label { font-size: 10px; }
    .cb-promo-badge-icon  { width: 12px; height: 12px; }
    .cb-promo-badge-inner { padding: 3px 7px; gap: 4px; }

    /* Featured card stacks vertically on mobile */
    .cb-featured-card {
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;
      min-height: auto;
      gap: 12px;
    }
    .cb-featured-img {
      width: 100%;
      height: auto;
      max-height: 180px;
      align-self: center;
    }

    /* Small cards tighter */
    .cb-small-card { height: auto; min-height: 200px; padding-bottom: 12px; }
    .cb-small-card-img { max-height: 130px; }
    .cb-small-card h3 { font-size: 16px !important; }
    .cb-small-card p { font-size: 13px !important; }
  }

  /* ── Small mobile (max 480px) ── */
  @media (max-width: 480px) {
    .cb-section { padding: 16px 10px 24px; margin-top: -20px; }
    .cb-top-row, .cb-bottom-row { gap: 8px; }
    .cb-main-heading { font-size: 22px; }
    .cb-main-desc { font-size: 14px; }
    .cb-small-card { min-height: 180px; }
    .cb-small-card-img { max-height: 110px; }
    .cb-featured-img { max-height: 150px; }

    /* Badge even tighter on very small screens */
    .cb-promo-badge-label { font-size: 9px; }
    .cb-promo-badge-inner { padding: 3px 6px; }
  }
`;

// ── PromotionBadge ────────────────────────────────────────────────────────────
// Rendered in normal document flow (flex child), NOT absolutely positioned,
// so it never overlaps the card heading.
const PromotionBadge = ({ icon, label, variant }) => (
  <div className={`cb-promo-badge-wrap${variant === "new" ? " cb-promo-badge-wrap--new" : ""}`}>
    <div className={`cb-promo-badge-inner${variant === "new" ? " cb-promo-badge-inner--new" : ""}`}>
      <img
        src={icon}
        alt=""
        aria-hidden="true"
        className="cb-promo-badge-icon"
      />
      <span className="cb-promo-badge-label">{label}</span>
    </div>
  </div>
);

// ── SmallCard ─────────────────────────────────────────────────────────────────
const SmallCard = ({ item, onNavigate }) => {
  const promoKey  = item.subheading?.toLowerCase();
  const promotion = PROMOTIONS[promoKey] || null;

  return (
    <div
      className="cb-small-card"
      onClick={() => onNavigate(item.subheading)}
      style={{ cursor: "pointer" }}
    >
      {/* Badge — sits above the title in flow, never overlaps it */}
      {promotion && (
        <PromotionBadge icon={promotion.icon} label={promotion.label} variant={promotion.variant} />
      )}

      <h3 style={gradientText}>
        {item.subheading}
      </h3>

      <p style={{
        fontFamily:    "Inter, sans-serif",
        fontWeight:    530,
        fontSize:      18,
        lineHeight:    1.4,
        letterSpacing: "0.02em",
        color:         "var(--color-text-subheading)",
        margin:        0,
        whiteSpace:    "pre-line",
      }}>
        {item.description}
      </p>

      {item.imgurl && (
        <div className="cb-small-card-img-wrap">
          <img src={item.imgurl} alt={item.subheading} className="cb-small-card-img" />
        </div>
      )}
    </div>
  );
};

// ── FeaturedCard ──────────────────────────────────────────────────────────────
const FeaturedCard = ({ item, onNavigate }) => {
  const promoKey  = item.subheading?.toLowerCase();
  const promotion = PROMOTIONS[promoKey] || null;

  return (
    <div
      className="cb-featured-card"
      onClick={() => onNavigate(item.subheading)}
    >
      <div className="cb-featured-text">
        {/* Badge — sits above the title in flow */}
        {promotion && (
          <PromotionBadge icon={promotion.icon} label={promotion.label} variant={promotion.variant} />
        )}
        <h3 style={gradientText}>{item.subheading}</h3>
        <p style={{
          fontFamily:    "Inter, sans-serif",
          fontWeight:    530,
          fontSize:      18,
          lineHeight:    1.5,
          letterSpacing: "0.02em",
          color:         "var(--color-text-subheading)",
          margin:        0,
        }}>
          {item.description}
        </p>
      </div>
      {item.imgurl && (
        <img src={item.imgurl} alt={item.subheading} className="cb-featured-img" />
      )}
    </div>
  );
};

// ── CurebaySolutions ──────────────────────────────────────────────────────────
const CurebaySolutions = ({ data = {} }) => {
  const navigate = useNavigate();
  const thirdsub = data?.thirdsub || [];

  const topRow    = thirdsub.slice(0, 4);
  const featured  = thirdsub[4];
  const bottomRow = thirdsub.slice(5, 9);

  // "CureBay Solutions" → first word in primary, rest in green
  const [headingFirst, ...headingWords] = (data.heading || "CureBay Solutions").split(" ");
  const headingRest = headingWords.join(" ");

  const handleNavigate = (subheading) => {
    const key = subheading?.toLowerCase() || "";
    if (DIRECT_ROUTES[key]) {
      navigate(DIRECT_ROUTES[key]);
    } else if (endpointBase) {
      window.location.href = `${endpointBase}/${key}`;
    }
  };

  return (
    <>
      <style>{styles}</style>
      <section className="cb-section">

        <div className="cb-top-row">
          {topRow.map(item => (
            <SmallCard key={item.id} item={item} onNavigate={handleNavigate} />
          ))}
        </div>

        <div className="cb-middle-row">
          <div className="cb-heading-block">
            <h2 className="cb-main-heading">
              {headingFirst}{headingRest && " "}
              {headingRest && <span className="cb-main-heading-accent">{headingRest}</span>}
            </h2>
            <p className="cb-main-desc">
              {data.description || "Here AI and empathy come together to deliver personalized health outcomes"}
            </p>
          </div>
          {featured && (
            <FeaturedCard item={featured} onNavigate={handleNavigate} />
          )}
        </div>

        <div className="cb-bottom-row">
          {bottomRow.map(item => (
            <SmallCard key={item.id} item={item} onNavigate={handleNavigate} />
          ))}
        </div>

      </section>
    </>
  );
};

export default CurebaySolutions;